import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './navbar';
import Footer from './footer';
import { AddStrategyDescription } from './services/strategyService';
import '../index.css';

const StrategyDescriptionTable = () => {
  const [strategyDescriptions, setStrategyDescriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
    const token = window.sessionStorage.getItem("jwtToken");
  const [newStrategyDescription, setNewStrategyDescription] = useState({
    strategyDescriptionCode: '',
    videoLink: '',
    strategyDescription: '',
    status: 1,
  });
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15); // State for rows per page
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStrategyDescriptions = async () => {
      try {
        const response = await fetch(`${BASE_URL}/getStrategyDescription`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        if (!response.ok) {
          throw new Error('Failed to fetch strategy descriptions');
        }
        const data = await response.json();
        setStrategyDescriptions(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchStrategyDescriptions();
  }, [BASE_URL]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewStrategyDescription((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const addedData = await AddStrategyDescription(newStrategyDescription);

      setStrategyDescriptions((prev) => [...prev, addedData]);
      setShowModal(false);
      setNewStrategyDescription({
        strategyDescriptionCode: '',
        videoLink: '',
        strategyDescription: '',
        status: 1,
      });

      const newTotalPages = Math.ceil((strategyDescriptions.length + 1) / itemsPerPage);
      setCurrentPage(newTotalPages);
    } catch (error) {
      const errorMessage = error.message.includes('Failed to parse')
        ? 'Unexpected response from server. Please try again.'
        : 'Failed to add strategy description.';
      alert(errorMessage);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1); // Reset to the first page on size change
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = strategyDescriptions.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(strategyDescriptions.length / itemsPerPage);

  if (loading) return <p>Loading strategy descriptions...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <>
      <Navbar />
      <div className="main-content">
        <div className="container-fluid">
          <h4 className="fw-bold">Strategy Description</h4>
          <div className="d-flex justify-content-between mb-3">
            <button className="btn btn-primary" onClick={() => navigate(-1)}>
              Back
            </button>
            <button className="btn btn-primary" onClick={() => setShowModal(true)}>
              Add Strategy Description
            </button>
          </div>



          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Strategy Description Code</th>
                  <th>Video Link</th>
                  <th>Strategy Description</th>
                  <th>Status</th>
                  <th>Created On</th>
                  <th>Modified On</th>
                </tr>
              </thead>
              <tbody>
                {currentItems.length > 0 ? (
                  currentItems.map((item, index) => (
                    <tr key={item.id}>
                      <td>{indexOfFirstItem + index + 1}</td>
                      <td>{item.strategyDescriptionCode}</td>
                      <td>
                        <a href={item.videoLink} target="_blank" rel="noopener noreferrer">
                          View Video
                        </a>
                      </td>
                      <td>{item.strategyDescription}</td>
                      <td>{item.status === 1 ? 'Active' : 'Inactive'}</td>
                      <td>{item.createdOn || 'N/A'}</td>
                      <td>{item.modifiedOn || 'N/A'}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7">No strategy descriptions available...</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <nav className="d-flex justify-content-center mt-3">
            <ul className="pagination">
              <li className="page-item">
                <button
                  className="page-link"
                  disabled={currentPage === 1}
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  Previous
                </button>
              </li>
              {[...Array(totalPages)].map((_, index) => (
                <li className="page-item" key={index}>
                  <button
                    className={`page-link ${currentPage === index + 1 ? 'active' : ''}`}
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </button>
                </li>
              ))}
              <li className="page-item">
                <button
                  className="page-link"
                  disabled={currentPage === totalPages}
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  Next
                </button>
              </li>
            </ul>
            <div className="d-flex justify-content-between align-items-center mb-3">
            <ul>
              Show{' '}
              <select
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
                className="form-select d-inline-block w-auto"
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={15}>15</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>{' '}
              entries
            </ul>
          </div>
          </nav>

          {/* Modal for Adding Strategy Description */}
          {/* (The modal code remains the same as before) */}
          {showModal && (
            <div className="modal show" style={{ display: 'block' }}>
              <div className="modal-dialog" style={{ maxHeight: '80%', margin: 'auto', marginTop: '100px' }}>
                <div className="modal-content" style={{ backgroundColor: '#e6e8ec' }}>
                  <div className="modal-header">
                    <h5 className="modal-title">Add Strategy Description</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setShowModal(false)}
                    ></button>
                  </div>
                  <form onSubmit={handleFormSubmit}>
                    <div className="modal-body">
                      <div className="mb-3 d-flex align-items-center">
                        <label
                          htmlFor="strategyDescriptionCode"
                          className="form-label me-2"
                          style={{ minWidth: '180px' }}
                        >
                          Strategy Description Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="strategyDescriptionCode"
                          name="strategyDescriptionCode"
                          value={newStrategyDescription.strategyDescriptionCode}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="mb-3 d-flex align-items-center">
                        <label
                          htmlFor="videoLink"
                          className="form-label me-2"
                          style={{ minWidth: '180px' }}
                        >
                          Video Link
                        </label>
                        <input
                          type="url"
                          className="form-control"
                          id="videoLink"
                          name="videoLink"
                          value={newStrategyDescription.videoLink}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                      <div className="mb-3 d-flex align-items-center">
                        <label
                          htmlFor="strategyDescription"
                          className="form-label me-2"
                          style={{ minWidth: '180px' }}
                        >
                          Strategy Description
                        </label>
                        <textarea
                          className="form-control"
                          id="strategyDescription"
                          name="strategyDescription"
                          value={newStrategyDescription.strategyDescription}
                          onChange={handleInputChange}
                          required
                        ></textarea>
                      </div>
                      <div className="mb-3 d-flex align-items-center">
                        <label
                          htmlFor="status"
                          className="form-label me-2"
                          style={{ minWidth: '180px' }}
                        >
                          Status
                        </label>
                        <select
                          className="form-select"
                          id="status"
                          name="status"
                          value={newStrategyDescription.status}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Status</option>
                          <option value="0">Inactive</option>
                          <option value="1">Active</option>
                        </select>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setShowModal(false)}
                      >
                        Close
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};



export default StrategyDescriptionTable;
